import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const CarIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 20 15"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M18.75 5.75h-.8438L15.7359.8672A1.25 1.25 0 0 0 14.5938.125H5.4063A1.25 1.25 0 0 0 4.264.8672L2.0937 5.75H1.25a.625.625 0 0 0 0 1.25h.625v6.25a1.25 1.25 0 0 0 1.25 1.25H5a1.25 1.25 0 0 0 1.25-1.25V12h7.5v1.25A1.2501 1.2501 0 0 0 15 14.5h1.875a1.2501 1.2501 0 0 0 1.25-1.25V7h.625a.6248.6248 0 0 0 .625-.625.6247.6247 0 0 0-.625-.625ZM5.4062 1.375h9.1876l1.9445 4.375H3.4617l1.9446-4.375ZM16.875 13.25H15v-1.875a.6245.6245 0 0 0-.1831-.4419.6245.6245 0 0 0-.4419-.1831h-8.75a.6247.6247 0 0 0-.625.625v1.875H3.125V7h13.75v6.25Z"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
);

export default CarIcon;
